module.exports = __webpack_public_path__ + "img/stripe-logo.5d0b1a91.png";